import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import { LISTING_DETAILS_MESSAGES } from '../../util/constants';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  // const pickListingFields = (filteredConfigs, config) => {
  //   const { key, schemaType, enumOptions, showConfig = {} } = config;
  //   const listingType = publicData.listingType;
  //   const isTargetListingType = isFieldForListingType(listingType, config);
  //   const isTargetCategory = isFieldForCategory(config);

  //   const { isDetail, label } = showConfig;
  //   const publicDataValue = publicData[key];
  //   const metadataValue = metadata[key];
  //   const value = publicDataValue || metadataValue;

  //   if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
  //     const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
  //     const getBooleanMessage = value =>
  //       value
  //         ? intl.formatMessage({ id: 'SearchPage.detailYes' })
  //         : intl.formatMessage({ id: 'SearchPage.detailNo' });
  //     const optionConfig = findSelectedOption(value);

  //     return schemaType === 'enum'
  //       ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
  //       : schemaType === 'boolean'
  //       ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
  //       : schemaType === 'long'
  //       ? filteredConfigs.concat({ key, value, label })
  //       : filteredConfigs;
  //   }
  //   return filteredConfigs;
  // };

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    // Skip listing_pricing — all listings are fixed price so this detail is unnecessary
    if (key === 'listing_pricing') {
      return filteredConfigs;
    }

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      let customValue = value;

      const messages = LISTING_DETAILS_MESSAGES[key];

      if (messages) {
        const message = messages.find(msg => msg.id === value);
        if (message) {
          customValue = message.value;
        }
      }

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: customValue, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            {/* <span className={css.detailLabel}>{detail.label}</span> */}
            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
